import React from "react";
import { PlxsText } from "@plexlogic/plexus-ui";

interface DrawResultsSummaryProps {
  totalWinners: number;
  totalReserves: number;
  totalEntries?: number;
}

/**
 * Reusable component to display draw results summary
 * Used in both ConfirmationStep and DrawDetailComponent
 */
const DrawResultsSummary: React.FC<DrawResultsSummaryProps> = ({
  totalWinners,
  totalReserves,
  totalEntries,
}) => {
  return (
    <div
      style={{
        marginBottom: "var(--plexus-space-xl)",
        backgroundColor: "var(--plexus-color-surface-50)",
        borderRadius: "var(--plexus-border-radius-md)",
        padding: "var(--plexus-space-xl)",
        border: `var(--plexus-border-width-thin) solid var(--plexus-color-neutral-600)`,
      }}
    >
      <div
        style={{
          fontWeight: 600,
          color: "var(--plexus-color-positive-400)",
          marginBottom: "var(--plexus-space-lg)",
          fontSize: "1.1rem",
        }}
      >
        Draw Results Summary
      </div>
      <div
        style={{
          display: "grid",
          gap: "var(--plexus-space-lg)",
          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
        }}
      >
        <div>
          <div
            style={{
              fontWeight: 500,
              marginBottom: "var(--plexus-space-xs)",
              color: "var(--plexus-color-neutral-200)",
            }}
          >
            Total Winners
          </div>
          <div
            style={{
              fontWeight: 600,
              color: "var(--plexus-color-positive-400)",
              fontSize: "1.25rem",
            }}
          >
            <PlxsText size="sm">{totalWinners}</PlxsText>
          </div>
        </div>
        <div>
          <div
            style={{
              fontWeight: 500,
              marginBottom: "var(--plexus-space-xs)",
              color: "var(--plexus-color-neutral-200)",
            }}
          >
            Total Reserves
          </div>
          <div
            style={{
              fontWeight: 600,
              color: "var(--plexus-color-positive-400)",
              fontSize: "1.25rem",
            }}
          >
            <PlxsText size="sm">{totalReserves}</PlxsText>
          </div>
        </div>
        {totalEntries !== undefined && (
          <div>
            <div
              style={{
                fontWeight: 500,
                marginBottom: "var(--plexus-space-xs)",
                color: "var(--plexus-color-neutral-200)",
              }}
            >
              Total Entries
            </div>
            <div
              style={{
                fontWeight: 600,
                color: "var(--plexus-color-positive-400)",
                fontSize: "1.25rem",
              }}
            >
              <PlxsText size="sm">{totalEntries}</PlxsText>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DrawResultsSummary;
